import Model from './Model'

export default class Project extends Model {
  resource() {
    return 'projects'
  }
}
